import { action, makeAutoObservable, observable, runInAction } from "mobx";
import ApiNsi from "../modules/api/Nsi";
import DefectFormApi from "../api/DefectForm";
import { WithBooleanFlag } from "./core";

export class Nsi {
  opfsList = [];
  iogvList = [];
  budgetList = [];
  orgTypeList = [];
  addressLegalList = [];
  addressFactList = [];
  addressGuids = [];
  ownershipTypeList = [];
  // opfsId = 0;
  // iogvId = 0;
  // bugetId = 0;
  // orgTypeId = 0;
  // ownershipTypeId = 0;
  ownershipType = "";
  addressLegal = "";
  addressFact = "";
  //devices
  deviceTypes = [];
  deviceStatuses = [];
  communalResources = [];
  calibrationIntervals = [];
  indicationTypes = [];
  recordingPeriods = [];
  //passport
  energyEfficiencyClasses = [];
  powerSupplyTypes = [];
  accountingEquipment = [];
  operationModes = [];
  energyTypes = [];
  uartFin = [];
  uartType = [];
  heatingControlSystemEquipment = [];
  thermalProtectionEquipment = [];
  //buildings
  rsoType101 = [];
  rsoType102 = [];
  rsoType2 = [];
  rsoType3 = [];
  rsoType6 = [];
  rsos = [];
  kosgus = [];
  ftg = [];
  //filters
  statuses = [];
  districts = [];
  restrictionNatures = [];
  organizations = [];
  //defects
  gridTypes = [];
  incidentStatuses = [];
  objectEntities = [];
  eventTypes = [];
  gasketTypes = [];
  complaintCodes = [];
  workProgresses = [];
  repairCategories = [];
  workStatus = [];
  activityTypes = [];
  coldWaterSupplyObjects = [];
  pipeTypes = [];
  defectExternalManifestation = [];
  heatSupplyObjects = [];
  producedWorks = [];
  workTypes = [];
  gasSupplyObjects = [];
  defectReasons = [];
  lightingProblemTypes = [];
  lightingObjects = [];
  //lighting
  lightningEquipmentLampLuminaireTypes = {};
  lightingEquipmentLuminaireTypes = [];
  lightingEquipmentLamps = [];
  lightingEquipment = [];
  orgIsLoading = new WithBooleanFlag(false);

  fuelType = [];

  isLoading = new WithBooleanFlag();

  constructor() {
    makeAutoObservable(this, {
      organizations: observable,
      fuelType: observable,
      rsos: observable,
      getOrganizations: action,
      getFuelType: action,
      getRsos: action,
    });
  }

  getOpfsList = async () => {
    try {
      const { data } = await ApiNsi.getOpfs();
      runInAction(() => {
        this.opfsList = data.items;
      });
    } catch (error) {
      console.log(error);
    }
  };

  getIogvList = async () => {
    try {
      const { data } = await ApiNsi.getIogvs();
      runInAction(() => {
        this.iogvList = data.items;
      });
    } catch (error) {
      console.log(error);
    }
  };
  getBudgetList = async () => {
    try {
      const { data } = await ApiNsi.getBudgetOrgs();
      runInAction(() => {
        this.budgetList = data.items;
      });
    } catch (error) {
      console.log(error);
    }
  };

  getOrgType = async () => {
    try {
      const { data } = await ApiNsi.getOrganizationTypes();
      runInAction(() => {
        this.orgTypeList = data.items;
      });
    } catch (error) {
      console.log(error);
    }
  };
  getAddressLegal = async (value) => {
    try {
      const { data } = await ApiNsi.getFias(value);
      runInAction(() => {
        this.addressLegalList = data.items;
      });
    } catch (error) {
      console.log(error);
    }
  };
  getAddressFact = async (value) => {
    try {
      const { data } = await ApiNsi.getFias(value);
      runInAction(() => {
        this.addressFactList = data.items;
      });
    } catch (error) {
      console.log(error);
    }
  };
  getAddressGuids = async (value) => {
    try {
      const { data } = await ApiNsi.getAddressGuids(value);
      runInAction(() => {
        this.addressGuids = data.items;
      });
    } catch (error) {
      console.log(error);
    }
  };
  getOwnershipTypes = async () => {
    try {
      const { data } = await ApiNsi.getOwnershipTypes();
      runInAction(() => {
        this.ownershipTypeList = data.items;
      });
    } catch (error) {
      console.log(error);
    }
  };
  //Devices
  getDeviceTypes = async () => {
    try {
      const { data } = await ApiNsi.getDeviceTypes();
      runInAction(() => {
        this.deviceTypes = data.items;
      });
    } catch (error) {
      console.log(error);
    }
  };
  getDeviceStatuses = async () => {
    try {
      const { data } = await ApiNsi.getDeviceStatuses();
      runInAction(() => {
        this.deviceStatuses = data.items;
      });
    } catch (error) {
      console.log(error);
    }
  };
  getCommunalResources = async (buildingId) => {
    this.isLoading.setTrue();
    try {
      const { data } = await ApiNsi.getCommunalResources(buildingId);
      runInAction(() => {
        this.communalResources = data.items;
      });
    } catch (error) {
      console.log(error);
    } finally {
      this.isLoading.setFalse();
    }
  };
  getCalibrationIntervals = async () => {
    try {
      const { data } = await ApiNsi.getCalibrationIntervals();
      runInAction(() => {
        this.calibrationIntervals = data.items;
      });
    } catch (error) {
      console.log(error);
    }
  };

  getIndicationTypes = async () => {
    try {
      const { data } = await ApiNsi.getIndicationTypes();
      runInAction(() => {
        this.indicationTypes = data.items;
      });
    } catch (error) {
      console.log(error);
    }
  };
  getRecordingPeriods = async () => {
    try {
      const { data } = await ApiNsi.getRecordingPeriods();
      runInAction(() => {
        this.recordingPeriods = data.items;
      });
    } catch (error) {
      console.log(error);
    }
  };
  //passport
  getEnergyEfficiencyClasses = async () => {
    try {
      const { data } = await ApiNsi.getEnergyEfficiencyClasses();
      runInAction(() => {
        this.energyEfficiencyClasses = data.items;
      });
    } catch (error) {
      console.log(error);
    }
  };
  getPowerSupplyTypes = async () => {
    try {
      const { data } = await ApiNsi.getPowerSupplyTypes();
      runInAction(() => {
        this.powerSupplyTypes = data.items;
      });
    } catch (error) {
      console.log(error);
    }
  };

  getAccountingEquipment = async () => {
    try {
      const { data } = await ApiNsi.getAccountingEquipment();
      runInAction(() => {
        this.accountingEquipment = data.items;
      });
    } catch (error) {
      console.log(error);
    }
  };

  getHeatingControlSystemEquipment = async () => {
    try {
      const { data } = await ApiNsi.getHeatingControlSystemEquipment();
      runInAction(() => {
        this.heatingControlSystemEquipment = data.items;
      });
    } catch (error) {
      console.log(error);
    }
  };

  getThermalProtectionEquipment = async () => {
    try {
      const { data } = await ApiNsi.getThermalProtectionEquipment();
      runInAction(() => {
        this.thermalProtectionEquipment = data.items;
      });
    } catch (error) {
      console.log(error);
    }
  };

  getOperationModes = async () => {
    try {
      const { data } = await ApiNsi.getOperationModes();
      runInAction(() => {
        this.operationModes = data.items;
      });
    } catch (error) {
      console.log(error);
    }
  };
  getEnergyTypes = async () => {
    try {
      const { data } = await ApiNsi.getEnergyTypes();
      runInAction(() => {
        this.energyTypes = data.items;
      });
    } catch (error) {
      console.log(error);
    }
  };
  getUartTypes = async () => {
    try {
      const { data } = await ApiNsi.getUartTypes();
      runInAction(() => {
        this.uartType = data.items;
      });
    } catch (error) {
      console.log(error);
    }
  };
  getUartFin = async () => {
    try {
      const { data } = await ApiNsi.getUartFin();
      runInAction(() => {
        this.uartFin = data.items;
      });
    } catch (error) {
      console.log(error);
    }
  };

  //buildings
  getRso = async () => {
    try {
      const { data } = await ApiNsi.getRso(101);
      runInAction(() => {
        this.rsoType101 = data.items;
      });
    } catch (error) {
      console.log(error);
    }

    try {
      const { data } = await ApiNsi.getRso(102);
      runInAction(() => {
        this.rsoType102 = data.items;
      });
    } catch (error) {
      console.log(error);
    }

    try {
      const { data } = await ApiNsi.getRso(2);
      runInAction(() => {
        this.rsoType2 = data.items;
      });
    } catch (error) {
      console.log(error);
    }

    try {
      const { data } = await ApiNsi.getRso(3);
      runInAction(() => {
        this.rsoType3 = data.items;
      });
    } catch (error) {
      console.log(error);
    }

    try {
      const { data } = await ApiNsi.getRso(6);
      runInAction(() => {
        this.rsoType6 = data.items;
      });
    } catch (error) {
      console.log(error);
    }
  };
  getRsos = async () => {

    try {
      const { data } = await ApiNsi.getRsos();
      runInAction(() => {
        this.rsos = data.items;
      });
    } catch (error) {
      console.log(error);
    }
  }
  getKosgus = async () => {
    try {
      const { data } = await ApiNsi.getKosgus();
      runInAction(() => {
        this.kosgus = data.items;
      });
    } catch (error) {
      console.log(error);
    }
  };
  getFtg = async () => {
    this.isLoading.setTrue();
    try {
      const { data } = await ApiNsi.getFtg();
      runInAction(() => {
        this.ftg = data.items;
      });
    } catch (error) {
      console.log(error);
    } finally {
      this.isLoading.setFalse();
    }
  };
  //filters
  getStatuses = async () => {
    try {
      const { data } = await ApiNsi.getStatuses();
      runInAction(() => {
        this.statuses = data.items;
      });
    } catch (error) {
      console.log(error);
    }
  };
  getDistricts = async () => {
    try {
      const { data } = await ApiNsi.getDistricts();
      runInAction(() => {
        this.districts = data.items;
      });
    } catch (error) {
      console.log(error);
    }
  };
  getRestrictionNatures = async () => {
    try {
      const { data } = await ApiNsi.getRestrictionNatures();
      runInAction(() => {
        this.restrictionNatures = data.items;
      });
    } catch (error) {
      console.log(error);
    }
  };

  getOrganizations = async (id?) => {
    this.orgIsLoading.setTrue();
    try {
      const { data } = await DefectFormApi.getOrganizations(id);
      runInAction(() => {
        this.organizations = data;
      });
    } catch (error) {
      console.log(error);
    } finally {
      this.orgIsLoading.setFalse();
    }
  };

  //defects
  getGridTypes = async () => {
    try {
      const { data } = await ApiNsi.getGridTypes();
      runInAction(() => {
        this.gridTypes = data.items;
      });
    } catch (error) {
      console.log(error);
    }
  };

  getIncidentStatuses = async () => {
    try {
      const { data } = await ApiNsi.getIncidentStatuses();
      runInAction(() => {
        this.incidentStatuses = data.items;
      });
    } catch (error) {
      console.log(error);
    }
  };

  getObjectEntities = async () => {
    try {
      const { data } = await ApiNsi.getObjectEntities();
      runInAction(() => {
        this.objectEntities = data.items;
      });
    } catch (error) {
      console.log(error);
    }
  };

  getEventTypes = async () => {
    try {
      const { data } = await ApiNsi.getEventTypes();
      runInAction(() => {
        this.eventTypes = data.items;
      });
    } catch (error) {
      console.log(error);
    }
  };

  getGasketTypes = async () => {
    try {
      const { data } = await ApiNsi.getGasketTypes();
      runInAction(() => {
        this.gasketTypes = data.items;
      });
    } catch (error) {
      console.log(error);
    }
  };

  getComplaintCodes = async () => {
    try {
      const { data } = await ApiNsi.getComplaintCodes();
      runInAction(() => {
        this.complaintCodes = data.items;
      });
    } catch (error) {
      console.log(error);
    }
  };

  getRepairCategories = async () => {
    try {
      const { data } = await ApiNsi.getRepairCategories();
      runInAction(() => {
        this.repairCategories = data.items;
      });
    } catch (error) {
      console.log(error);
    }
  };

  getWorkStatus = async () => {
    try {
      const { data } = await ApiNsi.getWorkStatus();
      runInAction(() => {
        this.workStatus = data.items;
      });
    } catch (error) {
      console.log(error);
    }
  };

  getWorkProgresses = async () => {
    try {
      const { data } = await ApiNsi.getWorkProgresses();
      runInAction(() => {
        this.workProgresses = data.items;
      });
    } catch (error) {
      console.log(error);
    }
  };

  getActivityTypes = async () => {
    try {
      const { data } = await ApiNsi.getActivityTypes();
      runInAction(() => {
        this.activityTypes = data.items;
      });
    } catch (error) {
      console.log(error);
    }
  };

  getColdWaterSupplyObjects = async () => {
    try {
      const { data } = await ApiNsi.getColdWaterSupplyObjects();
      runInAction(() => {
        this.coldWaterSupplyObjects = data.items;
      });
    } catch (error) {
      console.log(error);
    }
  };

  getPipeTypes = async () => {
    try {
      const { data } = await ApiNsi.getPipeTypes();
      runInAction(() => {
        this.pipeTypes = data.items;
      });
    } catch (error) {
      console.log(error);
    }
  };

  getDefectExternalManifestation = async () => {
    try {
      const { data } = await ApiNsi.getDefectExternalManifestation();
      runInAction(() => {
        this.defectExternalManifestation = data.items;
      });
    } catch (error) {
      console.log(error);
    }
  };

  getHeatSupplyObjects = async () => {
    try {
      const { data } = await ApiNsi.getHeatSupplyObjects();
      runInAction(() => {
        this.heatSupplyObjects = data.items;
      });
    } catch (error) {
      console.log(error);
    }
  };

  getProducedWorks = async () => {
    try {
      const { data } = await ApiNsi.getProducedWorks();
      runInAction(() => {
        this.producedWorks = data.items;
      });
    } catch (error) {
      console.log(error);
    }
  };

  getWorkTypes = async () => {
    try {
      const { data } = await ApiNsi.getWorkTypes();
      runInAction(() => {
        this.workTypes = data.items;
      });
    } catch (error) {
      console.log(error);
    }
  };

  getGasSupplyObjects = async () => {
    try {
      const { data } = await ApiNsi.getGasSupplyObjects();
      runInAction(() => {
        this.gasSupplyObjects = data.items;
      });
    } catch (error) {
      console.log(error);
    }
  };

  getDefectReasons = async () => {
    try {
      const { data } = await ApiNsi.getDefectReasons();
      runInAction(() => {
        this.defectReasons = data.items;
      });
    } catch (error) {
      console.log(error);
    }
  };

  getLightingProblemTypes = async () => {
    try {
      const { data } = await ApiNsi.getLightingProblemTypes();
      runInAction(() => {
        this.lightingProblemTypes = data.items;
      });
    } catch (error) {
      console.log(error);
    }
  };

  getLightingObjects = async () => {
    try {
      const { data } = await ApiNsi.getLightingObjects();
      runInAction(() => {
        this.lightingObjects = data.items;
      });
    } catch (error) {
      console.log(error);
    }
  };

  //lighting
  getLightingEquipmentLuminaireTypes = async () => {
    this.isLoading.setTrue();

    try {
      const { data } = await ApiNsi.getLightingEquipmentLuminaireTypes();
      runInAction(() => {
        this.lightingEquipmentLuminaireTypes = data.items;
      });
    } catch (error) {
      runInAction(() => {
        console.log(error);
      });
    } finally {
      this.isLoading.setFalse();
    }
  };
  getLightingEquipmentLamps = async () => {
    this.isLoading.setTrue();
    try {
      const { data } = await ApiNsi.getLightingEquipmentLamps();
      runInAction(() => {
        this.lightingEquipmentLamps = data.items;
      });
    } catch (error) {
      runInAction(() => {
        console.log(error);
      });
    } finally {
      this.isLoading.setFalse();
    }
  };
  getLightingEquipment = async () => {
    this.isLoading.setTrue();
    try {
      const { data } = await ApiNsi.getLightingEquipment();
      runInAction(() => {
        this.lightingEquipment = data.items;
      });
    } catch (error) {
      runInAction(() => {
        console.log(error);
      });
    } finally {
      this.isLoading.setFalse();
    }
  };
  getLightningEquipmentLampLuminaireTypes = async () => {
    this.isLoading.setTrue();
    try {
      const { data } = await ApiNsi.getLightningEquipmentLampLuminaireTypes();
      runInAction(() => {
        this.lightningEquipmentLampLuminaireTypes = data;
      });
    } catch (error) {
      runInAction(() => {
        console.log(error);
      });
    } finally {
      this.isLoading.setFalse();
    }
  };
  getFuelType = async () => {
    try {
      const { data } = await ApiNsi.getFuelType();
      runInAction(() => {
        this.fuelType = data.items;
      });
    } catch (error) {
      runInAction(() => {
        console.log(error);
      });
    }
  };
}

export default new Nsi();
